<template>
	<div>
		<v-card class="d-flex pa-5 mb-8 justify-space-between responsive">
			<div class="d-flex flex-row justify-space-around">
				<input
          v-model="formId"
          type="text"
          placeholder="ID Formulário"
          class="inputField h-48 mr-5 d-flex pl-2 rounded"
        >
				<input
          v-model="sourceId"
          type="text"
          placeholder="XPROMO ID"
          class="inputField h-48 mr-5 d-flex pl-2 rounded"
        >
				<input
          v-model="listCode"
          type="text"
          placeholder="List Code"
          class="inputField h-48 mr-5 d-flex pl-2 rounded"
        >
				<input
          v-model="emailPage"
          type="text"
          placeholder="Página email"
          class="inputField h-48 mr-5 d-flex pl-2 rounded"
        >
			</div>
			<div class="button-wrapper d-flex justify-space-between">
				<v-btn
					@click="filterList"
          :style="disabled ? 'background: var(--grey-day-030); border: var(--grey-day-030)' : 'background: var(--red); border: var(--red)'"
          :disabled="disabled"
          outlined
          height="48"
          class="d-flex align-center mr-5 responsiveBtn"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center justify-space-around"
						>
						<img class="pr-2" src="../../../../static/images/search.svg">
						<span style="color: var(--white)">Buscar</span>
					</div>
				</v-btn>
				<v-btn
          style="background: var(--white); color: var(--dark-grey)"
          outlined
          height="48"
          class="d-flex align-center b-clear responsiveBtn"
					@click="clearForm"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center"
						>
						<img class="pr-2" src="../../../../static/images/load.svg">
						Limpar
					</div>
				</v-btn>
			</div>
		</v-card>
		<!-- {{items}} -->

		<v-card class="responsive">
			<v-data-table
        :headers="headers"
				:items="items"
        :range="7"
        class="elevation-2 fs-16"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
        loader-height

      >
				<template 
					v-slot:item.id_source="{item}"
				>
					<v-tooltip v-if="item.id_source.length > 25" bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-bind="attrs"
						v-on="on">{{redux(item.id_source)}}</span>
						</template>
					<span>{{item.id_source}}</span>
					</v-tooltip>
					<span v-else>{{item.id_source}}</span>
				</template>
				<template 
					v-slot:item.list_code="{item}"
				>
					<v-tooltip v-if="item.list_code.length > 25" bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-bind="attrs"
						v-on="on">{{redux(item.list_code)}}</span>
						</template>
					<span>{{item.list_code}}</span>
					</v-tooltip>
					<span v-else>{{item.list_code}}</span>
				</template>
				<template v-slot:item.updated_at="{item}">
          {{formatDate(item.updated_at)}}
        </template>
				<template v-slot:item.actions="{item}" >
					<span class="d-flex flex-row">
						<button @click="setEditItem(item)" class="b-4 edit mr-2 d-flex justify-center align-center rounded">
							<img src="../../../../static/images/edit.svg"/>
						</button>
						<button @click="cancelItem(item)" class="b-4 d-flex remove justify-center align-center rounded">
							<img src="../../../../static/images/trash.svg"/>
						</button>
					</span>
        </template>
        <template v-slot:no-data>
          <span>Registro não encontrado</span>
        </template>
			</v-data-table>
		</v-card>

		<!-- Editing Item facebook -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="820"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <FacebookEdit v-on:close="drawer = false"/>
    </v-navigation-drawer>

		<!-- Remove -->
		<v-dialog v-model="cancel" scrollable max-width="500px">
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					<img style="width:20px" src="../../../../static/images/warning.svg" class="mr-4"> Confirmação de cancelamento</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="min-height: 150px; fontSize: 16px" class="d-flex flex-column align-center justify-center">
					Tem certeza que deseja cancelar <span class="font-weight-black">{{nameIdSource}} ?</span>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="justify-end">
					<v-btn color="grey lighten-2" class="text-capitalize" @click="cancel = false">
						Fechar
					</v-btn>
					<v-btn color="red lighten-2" class="text-capitalize" @click="setDelete(item)">
						Deletar Comunicação
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- PAgination -->
    <v-card class="mt-8">
			<div
				v-if="!loading"
				class="list-footer">
				<span></span>
				<v-pagination
          v-model="page"
          :length="pageCount"
          color="#F0F1F3"
        ></v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input
							v-model="goToPage"
							type="text"
						>
						<button
							@click="goToPageRequest"
							:disabled="disabledGoTo"
						>
							<div
								class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span
							:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
							class="goToPage--helptext"
						>
							A página deve estar entre 1 e {{pageCount}}
						</span>
					</label>
				</div>
			</div>
		</v-card>

		<div style="height: 5px"></div>
	</div>
</template>
<script>
// Lib
import { mapState, mapActions, mapMutations } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

//mixins
import date from '../../../mixins/date.js'
import toaster from '../../../mixins/toaster.js'

// Token
import VueCookies from 'vue-cookies'

// Componente
import FacebookEdit from './FacebookEdit.vue'

export default {
	mixins: [
		date,
		toaster
	],
	components: {
		ClipLoader,
		FacebookEdit
	},
	created () {
		this.fetchForms()
	},
	data () {
		return {
			goToPage: 1,
      showGoToPageHelpText: false,
      disabledGoTo: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      success: false,
      notification: false,
      drawer: false,
			loadingClear: false,
			disabled: true,
			selected: null,
      status: null,
      formId: "",
      sourceId: "",
      listCode: "",
      emailPage: "",
			cancel: false,
			nameIdSource: '',
			comunicationToDelete: {}
		}
	},
	computed: {
		...mapState("Facebook", {
      items: "items",
      loading: "loading",
      size: "size",
      pagination: "pagination",
    }),
		headers () {
      return [
				{ value:'id_form', text: 'ID Formulário' ,class: 'header-table grey lighten-2', width: '15%'},
        { value:'id_source', text: 'XPROMO ID' ,class: 'header-table grey lighten-2', width: '25%' },
        { value:'list_code', text: 'List Code' ,class: 'header-table grey lighten-2', width: '20%' },
        { value:'email_page', text: 'Página email' ,class: 'header-table grey lighten-2', width: '20%' },
        { value:'updated_at', text: 'ATUALIZADO EM', class:"grey lighten-2", sortable: true, width: '20%'},
        { value: 'actions', text: '', class:"grey lighten-2", width: '100px'  }
      ]
    },
	},
	methods: {
		redux (item) {
			if (item.length < 25) {
				return `${item.substring(0, 25)}`
			}
			return `${item.substring(0, 25)}...`
		},
		...mapActions("Facebook", ["getAllForms", "deleteFacebookForm"]),
		...mapMutations("Facebook", {
      setFacebookEdit: "SET_FACEBOOK_TO_EDIT",
      setLoading: "SET_LOADING",
      setStatusFilter: "SET_STATUS_FILTER",
      setProductFilter: "SET_PRODUCT_FILTER",
			setPage: "SET_PAGE",
    }),
		async goToPageRequest () {
      this.page = +this.goToPage
    },
		async fetchForms () {
			this.setLoading(true);
			const token = VueCookies.get('jwt-login')
			try {
				this.setStatusFilter(null);
				this.setProductFilter('');
				await this.getAllForms({ token: token });
				this.setLoading(false);
			} catch (error) {
				this.toaster(
					error.message,
					"red",
					true
				);
			}
		},
		async filterList() {
      this.disabled = true
      this.setLoading(true)
      this.setPage(0)
      const { formId, sourceId, listCode, emailPage } = this

      let dataFilter = ""

      if (formId) dataFilter += `&formId=${formId}`
      if (sourceId) dataFilter += `&sourceId=${sourceId}`
      if (listCode) dataFilter += `&listCode=${listCode}`
      if (emailPage) dataFilter += `&emailPage=${emailPage}`

      // const token = window.localStorage.getItem("authToken")
			const token = VueCookies.get('jwt-login')

      try {
        await this.getAllForms({ token: token, dataFilter })
        this.setLoading(false)
        this.disabled = false
      } catch (error) {
        return error
      }
    },
		async setDelete(data) {
			data = this.comunicationToDelete
			const token = VueCookies.get('jwt-login')
			try {
				await this.deleteFacebookForm({data: data, token});
				this.toaster('Comunicação cancelada!', 'var(--green)', true)
				this.getAllForms({ token: token })
				this.cancel = false
			}
			catch (error) {
				this.toaster(error, 'var(--red)', true)
			}
    },
		clearForm() {
      this.loadingClear = true
      this.formId=''
      this.sourceId=''
      this.listCode=''
      this.emailPage=''
      this.disabled = false
			this.fetchForms()
			this.loadingClear = false
    },
		setEditItem (item) {
			this.drawer = true
			this.setFacebookEdit(item)
		},
		cancelItem(item) {
			this.nameIdSource = item.id_source
			this.comunicationToDelete = item
			this.cancel = true
		}
	},
	watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.pageCount) {
        this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
        this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
		'formId' () {
      this.formId !== null ? this.disabled = false : this.disabled = true
    },
    'sourceId' () {
      this.sourceId !== null ? this.disabled = false : this.disabled = true
    },
    'listCode' () {
      this.listCode !== null ? this.disabled = false : this.disabled = true
    },
    'emailPage' () {
      this.emailPage !== null ? this.disabled = false : this.disabled = true
    }
  }
}
</script>
<style lang="scss" scoped>
.responsiveBtn {
	width: 120px ;
}
.edit {
	border: 2px solid var(--grey-day-020);
}
.remove {
	background: var(--red);
	border: 2px solid var(--red);
}
.b-4 {
	margin: 10px;
	height: 40px;
	width: 40px;
}

.header-table {
	font-size: 16px !important;
  height: 64px !important;
  background: var(--grey-day-020)!important;
}

.responsive {
	max-width: 1224px;
}

.inputField{
	border: 2px solid var(--grey-day-030);
	width: 211px;
}

.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
	margin: 80px 0 10px 0; 
	height: 64px;
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none
}

.goToPage {
	&--text {
		font-size: 14px;
		font-family: var(--dm-sans-regular);
		color: var(--dark-grey);
		margin-right: 20px;
	}

	label {
		border: 2px solid var(--grey-day-030);
		background: var(--white);
		border-radius: 4px;
		box-sizing: border-box;
		max-width: 84px;
		width: 80px;
		padding: 10px;
		position: relative;

		input {
			width: 54px;
			font-size: 1rem;
			color: var(--grey);
			font-family: var(--dm-sans-regular);
		}

		button {
			position: absolute;
			border-radius: 50%;
			border: none;
			padding: 0;
			top: 11px;
			right: 8px;
			background: var(--grey);
			cursor: pointer;

			i {
				color: var(--white);
				font-size: 1.25rem;
			}
		}

		button:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

	&--helptext {
		font-family: var(--dm-sans-regular);
		position: absolute;
		font-size: 12px;
		width: 120px;
		text-align: center;
		top: -55px;
		left: -24px;
		background: var(--dark-red);
		padding: 8px;
		color: var(--light-grey);
		border-radius: 4px;
	}

	.--hide-helptext {
		display: none;
	}

	.--show-helptext {
		display: block;
	}
}

@media screen and (max-width: 1377px) {
	.responsive {
		max-width: 819px;
	}

	.inputField {
		width: 115px;
	}

	.responsiveBtn {
		width: 110px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/Facebook/FacebookList.vue